(() => {
  const track = document.querySelector('[data-eride-tire-track]');
  if (!track) return;

  let ticking = false;

  const setProgress = () => {
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const raw = window.scrollY / max;
    const min = 56 / Math.max(window.innerWidth, 1);
    const progress = Math.min(1, Math.max(min, raw));
    track.style.setProperty('--eride-track', progress.toFixed(4));
    document.body.classList.toggle('eride-scrolled', window.scrollY > 8);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      setProgress();
      ticking = false;
    });
  };

  setProgress();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();
